import {
  customerEmailValidation, customerNameValidation,
  customerPhoneValidation,
  setRules, translate,
  translateTitleInScheme,
  validate
} from 'utils';
import { JSONSchema, TError } from 'models';

export const contactPersonValidation = (
  contacts: {
    first_name: string,
    last_name: string,
    email: string,
    phone: string,
  },
  contactsRequiredFields: string[],
  errorsUI: TError[],
  props?: JSONSchema,
) => {


  contactsRequiredFields.forEach((item) => {
    if (!contacts[item as 'email' | 'phone' | 'first_name' | 'last_name']) {
      return;
    }

    let pattern, regExpErrorMessage;

    if (item === 'email' && contacts.email) {
      const processedObj = customerEmailValidation();
      pattern = processedObj.pattern;
      regExpErrorMessage = processedObj.regExpErrorMessage;
    }

    if (item === 'phone' && contacts.phone) {
      const processedObj = customerPhoneValidation();
      pattern = processedObj.pattern;
      regExpErrorMessage = processedObj.regExpErrorMessage;
    }

    if (item === 'first_name' && contacts.first_name) {
      const processedObj = customerNameValidation();
      pattern = processedObj.pattern;
      regExpErrorMessage = processedObj.regExpErrorMessage;
    }

    if (item === 'last_name' && contacts.last_name) {
      const processedObj = customerNameValidation();
      pattern = processedObj.pattern;
      regExpErrorMessage = processedObj.regExpErrorMessage;
    }

    const rules = setRules({
      props,
      item,
      pattern,
      regExpErrorMessage
    });


    const errors = validate({
      field: item,
      parentField: 'contact_persons',
      listIndex: 0,
      fieldName: props && props[item] ? translateTitleInScheme(props[item]) : undefined,
      value: contacts[item as 'email' | 'phone'],
      rules,
      uncommonError: true
    });

    if (errors?.length) {
      errorsUI = [
        ...errorsUI,
        ...errors
      ];
    }
  });

  if (!contacts.phone && !contacts.email) {
    errorsUI.push({
      code: '',
      field: 'contact_persons',
      message: translate({ key: 'quote.participants.contact_person.validation.at_least_one_contact_method_required' }),
      parentField: 'contact_persons',
      listIndex: 0,
    });
  }

  return errorsUI;
};

